import React from 'react';
import { Select } from 'antd';
import i18next from 'i18next';
import { optionsLanguage } from './constants';
import st from './styles.module.scss';

const SelectLanguage = () => {
  const handleChange = value => {
    console.log('value', typeof value);
    localStorage.setItem('i18next', value);
    localStorage.setItem('i18lang', value);
    i18next.changeLanguage(value);
  };
  return (
    <div className={`custom-select ${st.selectLanguage}`}>
      <Select
        dropdownStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.9 )' }}
        suffixIcon={null}
        defaultValue={localStorage.getItem('i18lang') ? localStorage.getItem('i18lang') : 'en'}
        style={{
          width: 95,
        }}
        onChange={handleChange}
        options={optionsLanguage}
      />
    </div>
  );
};

export default SelectLanguage;
